import { useParams } from '@tanstack/react-router';
import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

const AccountScreen = lazy(() => import('../screens/account/AccountScreen.js'));

/** Compte (vague 5) : grille de sections ; `/compte/<section>` ouvre une section. */
export default function AccountPage() {
  const { section, accessId } = useParams({ strict: false }) as { section?: string; accessId?: string };
  return (
    <GarageGate>
      <AccountScreen section={accessId ? 'support' : (section ?? null)} accessId={accessId ?? null} />
    </GarageGate>
  );
}
